import React from 'react'
import { className } from '../type'

type Props = {
    title: string;
} & className

function Title({className, title}:Props) {
    return (
        <h1 className='bg-blue-200 p-8 bg-gradient-to-tr text-4xl font-bold'>{title}</h1>
    )
}

export default Title